import { Button, ClickAwayListener, Grid } from '@material-ui/core'
import Input from 'Components/Input'
import Title from 'Components/Title'
import Tooltip from 'Components/Tooltip'
import Utils from 'EurestoFonction/Utils'
import React, { useState } from 'react'

const Couvert = props =>
  <Grid item style={{
    width: '20%',
    padding: '1px 0px',
    paddingRight: props.quantite % 5 !== 0 && 1 || 0,
    paddingLeft: (props.quantite - 1) % 5 !== 0 && 1 || 0,
  }}>
    <Button
      fullWidth
      style={{
        padding: '2.5px 5px',
        border: '1px solid #393939',
        color: props.quantite === props.value && 'white' || 'black',
        backgroundColor: EurestoColor(props.quantite === props.value && 'EurestoPrimary' || 'EurestoText')
      }}
      disabled={props.disabled}
      onClick={_ => props.onChange(props.quantite, 'quantite')}>{props.quantite}
    </Button>
  </Grid>

const CouvertOver = props => {
  const [open, setOpen] = useState(false)
  const [quantite, setQuantite] = useState(props.quantite < 9 && 9 || props.quantite > props.max && props.max || props.quantite || 9)

  const onChangeQuantiteOver = (q) => {
    q = parseInt((q + '').replace(/\D/g, ''))
    //q = q < 9 && 9 || q > props.max && props.max || q
    setQuantite(q)
  }

  return <Grid item style={{
    width: '20%',
    padding: '1px 0px',
    paddingRight: props.quantite % 5 !== 0 && 1 || 0,
    paddingLeft: (props.quantite - 1) % 5 !== 0 && 1 || 0,
  }}>
    <Tooltip
      PopperProps={{
        disablePortal: true,
      }}
      interactive
      margin={'dense'}
      disableFocusListener
      disableHoverListener
      disableTouchListener
      open={open}
      title={
        <ClickAwayListener onClickAway={_ => {
          setOpen(false)
          if (!quantite || quantite < 9) {
            props.onChange(props.quantite || 9, 'quantite')
          } else if (quantite > props.max) {
            props.onChange(props.max, 'quantite')
          } else {
            props.onChange(quantite, 'quantite')
          }
        }}>
          <Grid item>
            <Input value={quantite}
                   variant={'standard'}
                   style={{
                     marginBottom: 0
                   }}
                   inputStyle={{
                     textAlign: 'center',
                     width: 40,
                     padding: 0,
                   }}
                   onChange={onChangeQuantiteOver}
                   InputProps={{
                     startAdornment: (
                       <Button style={{
                         position: 'relative',
                         marginLeft: -10,
                         width: 25,
                         height: '100%',
                         minWidth: 15,
                         padding: 0,
                         color: !(props.disabled || quantite <= 9) && 'white' || 'grey',
                         backgroundColor: EurestoColor(!(props.disabled || quantite <= 9) && 'EurestoPrimary' || 'EurestoText')
                       }}
                               disabled={props.disabled || quantite <= 9}
                               onClick={_ => onChangeQuantiteOver(quantite - 1)}>
                         <i className={'ei-commun_chevron ei-left'}
                            style={{
                              fontSize: 15,
                              padding: 5
                            }}/>
                       </Button>
                     ),
                     endAdornment: (
                       <Button style={{
                         position: 'relative',
                         marginRight: -10,
                         height: '100%',
                         width: 25,
                         minWidth: 15,
                         padding: 0,
                         color: !(props.disabled || quantite >= props.max) && 'white' || 'grey',
                         backgroundColor: EurestoColor(!(props.disabled || quantite >= props.max) && 'EurestoPrimary' || 'EurestoText')
                       }}
                               disabled={props.disabled || quantite >= props.max}
                               onClick={_ => onChangeQuantiteOver(quantite + 1)}>
                         <i className={'ei-commun_chevron ei-right'}
                            style={{
                              fontSize: 15,
                              padding: 5
                            }}/>
                       </Button>
                     )
                   }}/>
          </Grid>
        </ClickAwayListener>
      }>
      <Button
        fullWidth
        onClick={_ => {
          setOpen(true)
        }}
        style={{
          padding: '2.5px 5px',
          border: '1px solid #393939',
          color: props.quantite > 8 && 'white' || 'black',
          minWidth: '100%',
          backgroundColor: EurestoColor(props.quantite > 8 && 'EurestoPrimary' || 'EurestoText')
        }}
        disabled={props.disabled}>
        {props.quantite > 8 && props.quantite || '+'}
      </Button>
    </Tooltip>
  </Grid>
}

export default props => {
  return <Title spacing={8} title={'Quantité'} style={{ marginBottom: 2 }}>
    <Grid container direction='row'
          style={{ position: 'relative' }}>
      {
        (props.couverts && props.couverts.length > 0
          && props.couverts || Utils.generateArray(props.max > 8 && 8 || props.max)).map((n, couvert) =>
          <Couvert disabled={props.disabled} onChange={props.onChange} quantite={couvert + 1} value={props.value}/>)
      }
      {
        props.max > 8 &&
        <CouvertOver max={props.max} disabled={props.disabled} onChange={props.onChange} quantite={props.value}/>
      }
    </Grid>
  </Title>
}




// WEBPACK FOOTER //
// ./app/App/Module/Restaurant/Component/QuantiteCouvert/index.js